import { Center, Flex, Text } from "@chakra-ui/react"
import { roundToDP } from "@hydrologiq/common/helpers/math"
import { Customer } from "@hydrologiq/gql-experience/graphql"
import { BillButton } from "@hydrologiq/shared/content/components/Button"

function CustomerHydrogenTotal(props: { customer?: Customer; billable?: boolean }) {
  const { customer, billable = false } = props

  // Use the new field from customer if available
  const totalHydrogenKg = customer ? customer.totalHydrogenOnSiteKg : null

  if (totalHydrogenKg !== null && totalHydrogenKg !== undefined) {
    return (
      <Flex direction={{ base: "column", md: "row" }} justifyContent="space-between" gap={1}>
        <Center>
          <Text>{totalHydrogenKg > 0 ? roundToDP(totalHydrogenKg, 2) : "0"}</Text>
        </Center>
        {billable && (
          <Center>
            <BillButton disabled={totalHydrogenKg === 0} size="xs" />
          </Center>
        )}
      </Flex>
    )
  }

  // Fallback for backward compatibility
  return (
    <Flex maxWidth="175px" direction={{ base: "column", md: "row" }} justifyContent="space-between" gap={1}>
      <Center>0</Center>
      {billable && (
        <Center>
          <BillButton disabled={true} size="xs" />
        </Center>
      )}
    </Flex>
  )
}

export default CustomerHydrogenTotal
